import Countdown from "react-countdown";

interface AirdropClaimCountdownProps {
  airdropStart?: string;
  airdropEnd?: string;
  claimStart?: string;
  claimEnd?: string;
}

const AirdropClaimCountdown = ({
  airdropStart,
  airdropEnd,
  claimStart,
  claimEnd,
}: AirdropClaimCountdownProps) => {
  const now = Date.now();
  const times = {
    airdropStart: airdropStart ? new Date(airdropStart).getTime() : undefined,
    airdropEnd: airdropEnd ? new Date(airdropEnd).getTime() : undefined,
    claimStart: claimStart ? new Date(claimStart).getTime() : undefined,
    claimEnd: claimEnd ? new Date(claimEnd).getTime() : undefined,
  };
  const isAirdropEnded = times.airdropEnd && now > times.airdropEnd;

  const getStatus = () => {
    if (!isAirdropEnded && times.airdropStart && times.airdropEnd) {
      return {
        text:
          now < times.airdropStart ? "AIRDROP STARTS IN" : "AIRDROP ENDS IN",
        date: now < times.airdropStart ? times.airdropStart : times.airdropEnd,
      };
    }
    if (times.claimStart && times.claimEnd && now <= times.claimEnd) {
      return {
        text:
          now < times.claimStart
            ? "Rewards claim opens in"
            : "Rewards claim expires in",
        date: now < times.claimStart ? times.claimStart : times.claimEnd,
      };
    }
    return {
      text:
        times.claimEnd && now > times.claimEnd
          ? "Rewards claim expired"
          : "AIRDROP ENDED",
      date: undefined,
    };
  };

  const renderTime = ({ days, hours, minutes, seconds, completed }: any) => (
    <>
      {completed ? "00" : days}
      <span className="opacity-30">D </span>
      {completed ? "00" : hours}
      <span className="opacity-30">H </span>
      {completed ? "00" : minutes}
      <span className="opacity-30">M </span>
      {completed ? "00" : seconds}
      <span className="opacity-30">S</span>
    </>
  );
  const { text, date } = getStatus();

  return (
    <>
      <div className="font-medium text-xl uppercase">{text}</div>
      <div className="mt-4 font-bold text-2xl xs:text-[28px] xl:text-[32px] leading-[1] tracking-[1.5px] md:tracking-[3px]">
        {date ? (
          <Countdown date={date} renderer={renderTime} />
        ) : (
          <>
            00<span className="opacity-30">D </span>00
            <span className="opacity-30">H </span>00
            <span className="opacity-30">M </span>00
            <span className="opacity-30">S</span>
          </>
        )}
      </div>
    </>
  );
};

export default AirdropClaimCountdown;
